import { Body } from "@components/Typography";
import { useTheme } from "@hooks";
import { useStyles } from "./styles";
import { ContactLogoProps } from "./types";

export const ContactLogo = ({ initials = "", color: colorProp }: ContactLogoProps) => {
  const { theme } = useTheme();
  const styles = useStyles();

  const color = colorProp ?? theme.contact.item1;

  if (!initials) return null;

  return (
    <div style={{ ...styles.contact, ...{ backgroundColor: color } }}>
      <Body>{initials}</Body>
    </div>
  );
};
